<template>
	<!-- 账单明细表 -->
	<div class="billDetails public_Spacing ">
		<div class="pulbic_oparetionBlock">
			<div class="public_criteriaRange">
				<div class="public_singleMenu" v-if="this.userobj.pertb005.pertb005cb00 =='CUS-1'">
					<label class="public_lbSty">客户：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="customer" placeholder="请选择" filterable remote :remote-method="filterCustomer">
						<el-option v-for="item in filteredCustomerOptions" :label="item.ORMTB410CA00" :value="item.ORMTB410ID">
						</el-option>
					</el-select>
				</div>
				<!-- <div class="public_singleMenu">
					<label class="public_lbSty">流水号：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="el-input__inner pulic_carNumber" type="text" placeholder="请输入" v-model="carNum"/>
						</div>
					</div>
				</div> -->
				<!-- <div class="public_singleMenu">
					<label class="public_lbSty">变动类型：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="operateValue" placeholder="请选择">
						<el-option v-for="item in operateOptions" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div> -->
				<div class="public_singleMenu">
					<label class="public_lbSty">操作类型：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="numberValue" placeholder="请选择">
						<el-option v-for="item in numberOptions" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="public_singleMenu">
					<label class="public_lbSty">充值渠道：</label>
					<el-select v-model="RechargetypeValue" placeholder="请选择">
						<el-option v-for="item in RechargetypeOptions"
							:label="item.SETTB208CA01" :value="item.SETTB208CA01">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="public_operatArea">
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive?'public_dateActive':''"
					@click="getNowDay">当日</span>
				<span class="public_operatArea_yesterday pulic_cursor"
					:class="dateYesterdayActive?'public_dateActive':''" @click="getYesterday">昨天</span>
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive?'public_dateActive':''"
					@click="getNowMonth">当月</span>
				<span class="public_operatArea_yesterday pulic_cursor"
					:class="dateLastMonthActive?'public_dateActive':''" @click="getLastMonth">上月</span>
				<div class="public_operatArea_timePicker pulic_cursor">
					<el-date-picker v-model="date" type="datetimerange" range-separator="至" start-placeholder="开始日"
						end-placeholder="结束日" :picker-options="startDateDisabled" @change="datePickerChange"
						value-format="yyyy-MM-dd HH:mm:ss" class="pulic_cursor">
					</el-date-picker>
				</div>
				<div class="public_operatBtn" style="position: absolute;right: 0%;display: flex;">
					<button class="public_saleWater_chaxun pulic_cursor" @click="queryClick" v-shiroHiden="solelist"
						id="查询"><i class="iconfont icon-chaxun"></i>查询</button>
					<el-button class="public_saleWater_daochu pulic_cursor" @click="daochuExport" :loading="loadingBut"
						v-shiroHiden="solelist" id="导出"><i class="iconfont icon-daochu"></i>导出 <span
							v-if="confirmTxt >0">{{confirmTxt}}</span></el-button>

					<!-- <el-upload class="upload-demo" ref="upload" action="http://192.168.2.104:8081/exc/toExcel/download"
						:on-preview="handlePreview" :on-remove="handleRemove" :on-success="handSuccess"
						:before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed"
						:file-list="fileList">
						<el-button size="small" type="primary">上传</el-button>
					</el-upload> -->

					<!-- <el-button class="public_saleWater_daochu pulic_cursor" @click="" :loading="loadingBut"
						v-shiroHiden="solelist" id="导出"><i class="iconfont icon-daochu"></i>下载对账单
						<span v-if="confirmTxt >0">{{confirmTxt}}</span>
					</el-button> -->
				</div>

			</div>
		</div>
		<div v-shiroHiden="solelist" id="统计" style="width: 100%;">
			<div class="pulbic_oparetionBlock public_statisticsInfo">
				<div class="public_statistics billDetails-statistics">
					<div class="public_statisticsContent">
						<i style="color: #FF9E4F!important;font-size: 20px;" class="iconfont icon-chongzhi1"></i>
						<div class="payType">充值</div>
					</div>
					<ul class="billDetails-ul">
						<li class="pulic_statistics_titlt"><span class="totolTitle">总金额(元)</span><span class="Amount"
								style="color: #199FFF;">{{czSum}}</span></li>
						<li class="pulic_statistics_titlt"><span class="totolTitle">总单数(单)</span><span
								class="singular">{{czCount}}</span></li>
					</ul>
				</div>
				<div class="public_statistics billDetails-statistics">
					<div class="public_statisticsContent">
						<i style="color: #30A8FF!important;font-size: 20px;" class="iconfont icon-hongchong-copy"></i>
						<div class="payType">红冲</div>
					</div>
					<ul class="billDetails-ul">
						<li class="pulic_statistics_titlt"><span class="totolTitle">总金额(元)</span><span class="Amount"
								style="color: #FF5A45;">{{hcSum}}</span></li>
						<li class="pulic_statistics_titlt"><span class="totolTitle">总单数(单)</span><span
								class="singular">{{hcCount}}</span></li>
					</ul>
				</div>
				<div class="public_statistics billDetails-statistics">
					<div class="public_statisticsContent">
						<i style="color: #FF9E4F!important;font-size: 20px;" class="iconfont icon-koukuan1"></i>
						<div class="payType">扣款</div>
					</div>
					<ul class="billDetails-ul">
						<li class="pulic_statistics_titlt"><span class="totolTitle">总金额(元)</span><span class="Amount"
								style="color: #08D691;">{{KKSum}}</span></li>
						<li class="pulic_statistics_titlt"><span class="totolTitle">总单数(单)</span><span
								class="singular">{{KKCount}}</span></li>
					</ul>
				</div>
				<div class="public_statistics billDetails-statistics">
					<div class="public_statisticsContent">
						<i style="color: #08D691 !important;font-size: 20px;" class="iconfont icon-tuikuan1"></i>
						<div class="payType">退款</div>
					</div>
					<ul class="billDetails-ul">
						<li class="pulic_statistics_titlt"><span class="totolTitle">总金额(元)</span><span class="Amount"
								style="color: #FDB725;">{{tkSum}}</span></li>
						<li class="pulic_statistics_titlt"><span class="totolTitle">总单数(单)</span><span
								class="singular">{{tKCount}}</span></li>
					</ul>
				</div>

			</div>
		</div>
		<!--  -->
		<div class="billDetails-table pulbic_table_container pulbic_oparetionBlock">

			<el-table :data="tableData" style="width: 100%;" max-height="90%"
				:default-sort="{prop: 'waterNum', order: 'descending'}" stripe
				:header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}" class="public_tableColumn">
				<el-table-column prop="ORMTB520CA04" sortable label="时间">
				</el-table-column>
				<el-table-column prop="ORMTB510CA00" label="客户名称">
					<template slot-scope="scope">
						<p>
							<span>{{scope.row.ORMTB510CA00}}</span>
						</p>
						<p style="color: #999;">
							<span>{{scope.row.ORMTB520CA09}}</span>
						</p>

					</template>
				</el-table-column>
				<el-table-column prop="ORMTB520CA00" sortable label="操作类型">
				</el-table-column>
				<el-table-column prop="ORMTB520CA02" sortable label="原金额">
				</el-table-column>
				<el-table-column prop="ORMTB520CA01" sortable label="金额">
				</el-table-column>
				<el-table-column prop="ORMTB520CA03" sortable label="现金额">
				</el-table-column>
				<el-table-column v-if="this.userobj.pertb005.pertb005cb00 =='CUS-1'" prop="ORMTB420CD00" sortable
					label="优惠券抵扣">
				</el-table-column>
				<el-table-column prop="ORMTB520CA08" sortable
					label="充值渠道">
				</el-table-column>
				<el-table-column prop="ORMTB520CA05" sortable
					label="备注">
				</el-table-column>
				<el-table-column prop="ORMTB520CA10" sortable
					label="操作人员">
				</el-table-column>
				<!-- <el-table-column v-for='(item,index) in tableHeadList' :width="item.width" :prop="item.prop" :label="item.label"  :key="index"> </el-table-column> -->
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="recordCount">
				</el-pagination>
			</div>
		</div>

	</div>
</template>

<script>
import customerSearchMixin from '@/mixins/customerSearchMixin'
	import {
		saveAs
	} from 'file-saver';
	const operateOptions = [{
			value: '',
			label: '全部'
		},
		{
			value: 'CW',
			label: '财务'
		},
		{
			value: 'XS',
			label: '线上'
		},
		{
			value: 'XX',
			label: '线下'
		}
	];
	const numberOptions = [{
			value: '',
			label: '全部',
		},
		{

			value: '1',
			label: '充值'
		},
		{

			value: '0',
			label: '扣款'
		},
		// {

		// 	value: 'TK',
		// 	label: '退款'
		// },
		// {

		// 	value: 'SR',
		// 	label: '运费收入'
		// },
		// {

		// 	value: 'YDKK',
		// 	label: '运费运单扣款'
		// },
		// {

		// 	value: 'QX ',
		// 	label: '运单补偿'
		// },
		// {

		// 	value: 'BC',
		// 	label: '取消扣款'
		// },
		{

			value: '2',
			label: '红冲'
		}
	];
	export default {
  mixins: [customerSearchMixin],
		data() {
			return {
				loadingBut: false,
				confirmTxt: 0,
				confirmTxtdzd: 0,
				isRefresh: true,
				isRefreshSetInterval: '',
				dialogTableVisible: false,
				isIndeterminate: false,
				quanpDisabled: false,
				date: [],
				dateNowDayActive: false,
				dateYesterdayActive: false,
				dateNowMonthActive: false,
				dateLastMonthActive: false,
				startTime: '',
				endTime: '',
				tableData: [],
				RechargetypeValue: '',
				RechargetypeOptions: [],
				operateOptions: operateOptions,
				operateValue: '',
				numberOptions: numberOptions,
				numberValue: '',
				filteredCustomerOptions: [],
      customerOptions: [],
				customer: '',
				carNum: '',
				tableHeadSetShow: false,
				zhezhaoShow: false,
				checkAll: true,
				currentPage: 1,
				pageSize: 10,
				recordCount: 1,
				czSum: 0,
				czCount: 0,
				KKSum: 0,
				KKCount: 0,
				tkSum: 0,
				tKCount: 0,
				hcSum: 0,
				hcCount: 0,
				userobj: '',
				tableHeadList: [
					// {
					// 	prop:'ORMTB420CA07',
					// 	label:'时间',
					// },
					// {
					// 	prop:'ORMTB410CA00',
					// 	label:'客户名称',
					// },
					// {
					// 	prop:'ORMTB420CB00',
					// 	label:'流水号',
					// },
					{
						prop: 'ORMTB420CA01',
						label: '变动类型',
					},
					// {
					// 	prop:'beforeMoney',
					// 	label:'在线类型',
					// },
					{
						prop: 'ORMTB420CA00',
						label: '操作类型',
					},
					{
						prop: 'ORMTB420CA03',
						label: '原金额',
					},
					{
						prop: 'ORMTB420CA02',
						label: '金额',
					},
					{
						prop: 'ORMTB420CA04',
						label: '现金额',
					},
					{
						prop: 'ORMTB420CD00',
						label: '优惠券抵扣',
					},
					{
						prop: 'ORMTB420CC01',
						label: '操作人员',
					},
					// {
					// 	prop:'state',
					// 	label:'状态',
					// },
					{
						prop: 'ORMTB420CA06',
						label: '备注',
					},
				],
				currentUrl: this.$route.path,
				historyInfo: '',
				paymentcode: 1, //结算方式
				// 时间限制
				// 限制开始日期不能超过当前日期
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},

				solelist: [],
				listTick: null, // 列表定时器
				fileList: [],
			}
		},
		created() {
			var list = "";
			if (this.$route.query.mark != "" && this.$route.query.mark != null) {
				list = JSON.parse(sessionStorage.getItem("qpSolelist"));
				this.userobj = JSON.parse(sessionStorage.getItem('qpUobj'));
				this.CD01 = JSON.parse(sessionStorage.getItem('CD01'));
				var objInfo = JSON.parse(sessionStorage.getItem('objInfo'));
				sessionStorage.removeItem('qpSolelist');
				sessionStorage.removeItem('qpUobj');
				sessionStorage.removeItem('CD01');
				sessionStorage.removeItem('objInfo');
				this.customer = objInfo.customer;
				this.carNum = objInfo.carNum;
				this.operateValue = objInfo.operateValue;
				this.RechargetypeValue = objInfo.RechargetypeValue;
				this.numberValue = objInfo.numberValue;
				this.startTime = objInfo.startTime;
				this.endTime = objInfo.endTime;
				this.date = [this.startTime, this.endTime];
				this.customerOptions = objInfo.customerOptions;
				this.dateNowDayActive = objInfo.dateNowDayActive;
				this.dateYesterdayActive = objInfo.dateYesterdayActive;
				this.dateNowMonthActive = objInfo.dateNowMonthActive;
				this.dateLastMonthActive = objInfo.dateLastMonthActive;
				this.quanpDisabled = true;
			} else {
				list = this.$store.state.solelist;
				this.CD01 = this.$store.state.uobj.pertb005.pertb005cd01;
				this.userobj = this.$store.state.uobj;
				this.quanpDisabled = false;
			}
			var path = this.$route.path;
			if (path === "/billDetails") {
				path = "/Home" + path;
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			//获取历史数据信息
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if (this.historyInfo != null && this.historyInfo != '') {
				this.init()
			}
		},
		mounted() {
			if (this.historyInfo == null && this.$route.query.mark == null) {
				this.getNowDay();
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = true
			}
			this.enterpriceSelect()
			this.initTableList()
			this.CZTypeQuery()
			this.startListTimer()
		},
		activated() {
			this.startListTimer()
		},
		deactivated() {
			this.stopListTimer()
		},
		beforeDestroy() {
			this.stopListTimer()
			clearInterval(this.listTick)
			this.listTick = null
			this.startTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[0]));
			this.endTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[1]));
			//卸载前存储历史信息
			var obj = {
				customer: this.customer,
				carNum: this.carNum,
				currentPage: this.currentPage,
				pageSize: this.pageSize,
				operateValue: this.operateValue,
				RechargetypeValue: this.RechargetypeValue,
				numberValue: this.numberValue,
				startTime: this.startTime,
				endTime: this.endTime,
				dateNowDayActive: this.dateNowDayActive,
				dateYesterdayActive: this.dateYesterdayActive,
				dateNowMonthActive: this.dateNowMonthActive,
				dateLastMonthActive: this.dateLastMonthActive,
			}
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		methods: {
    filterCustomer(query) {
      if (!query) {
        this.filteredCustomerOptions = this.customerOptions.slice(0, 100)
        return
      }
      const q = query.toLowerCase()
      this.filteredCustomerOptions = this.customerOptions.filter(item =>
        (item.ORMTB410CA00 || '').toLowerCase().includes(q) ||
        (item.ORMTB410CA13 || '').toLowerCase().includes(q)
      )
    },
			startListTimer() {
				if (this.listTick) return
				this.listTick = setInterval(() => {
					if (document.hidden) return
					this.queryClick()
				}, 1000 * 60)
			},
			stopListTimer() {
				if (!this.listTick) return
				clearInterval(this.listTick)
				this.listTick = null
			},
			init() { //初始化数据
				this.customer = this.historyInfo.customer
				this.carNum = this.historyInfo.carNum
				this.currentPage = this.historyInfo.currentPage
				this.pageSize = this.historyInfo.pageSize
				this.operateValue = this.historyInfo.operateValue
				this.RechargetypeValue = this.historyInfo.RechargetypeValue
				this.numberValue = this.historyInfo.numberValue
				this.startTime = this.historyInfo.startTime
				this.endTime = this.historyInfo.endTime
				this.date = [this.startTime, this.endTime]
				this.dateNowDayActive = this.historyInfo.dateNowDayActive
				this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
				this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
				this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
			},


			submitUpload() {
				this.$refs.upload.submit();
			},

			//获取客户列表
			enterpriceSelect() {
				this.customerOptions = [{
					ORMTB410CA00: "全部",
					ORMTB410ID: ""
				}];
				// console.log(this.userobj)

				var data = {

				}
				if (this.userobj.pertb005.pertb005cb00 == "CUS-2") {
					data = {
						ORMTB400ID: this.userobj.ormtb410.ORMTB410ID //一级企业id
					}
				}
				if (this.userobj.pertb005.pertb005cb00 == "CUS-1") {
					data = {
						ORMTB400ID: this.userobj.ormtb400.ORMTB400ID //一级企业id
					}
				}

				var url1 = '/orm/ormtb420/selectOrmtb410CA00List'
				this.axios.post(url1, data).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.customerOptions = [...this.customerOptions, ...res.data.data]
          this.filteredCustomerOptions = this.customerOptions.slice(0, 100)
					}
				}).catch(() => {})
			},

			exportHandler(data) {
				let self = this;
				var url1 = '/exc/toExcel/download'
				// let params = {
				// 	name: data.name,
				// 	Id: data.id
				// };
				let formData = new FormData();
				      formData.append("file", data.raw);
				//请求接口
				this.axios.post(url1,formData,{
					responseType: 'blob', //定义接口响应的格式,很重要
				}).then(response => {
					
					let blob = new Blob([response.data]); //response.data为后端传的流文件
					let downloadFilename = data.name + ".xls"; //设置导出的文件名
					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
						//兼容ie浏览器
						window.navigator.msSaveOrOpenBlob(blob, downloadFilename)
					} else {
						//谷歌,火狐等浏览器
						let url = window.URL.createObjectURL(blob);
						let downloadElement = document.createElement("a");
						downloadElement.style.display = "none";
						downloadElement.href = url;
						downloadElement.download = downloadFilename;
						document.body.appendChild(downloadElement);
						downloadElement.click();
						document.body.removeChild(downloadElement);
						window.URL.revokeObjectURL(url);
					}
					self.$message({
						type: "success",
						message: '导出成功！'
					});

				}).catch(err => {
					self.$message({
						type: 'error',
						message: "导出失败！"
					});
				})
			},


			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handSuccess(res, file, fileList) {
				console.log(res)
				console.log(file)
				this.exportHandler(file)
				// 接口调用成功后文件下载
				// let contentType = res.headers['content-type']
				// let contentDisposition = res.headers['content-disposition']
				// if (contentType.indexOf('application/json') !== -1) {} 
				// else {
				// contentDisposition = contentDisposition.split(';')[1]
				// let filename = contentDisposition.split('=')[1]
				// let filenameStr = window.decodeURI(filename.split(',')[0], 'utf-8')
				// const blob = new Blob([res.data], {
				// 	type: 'application/vnd.ms-excel'
				// })
				// const link = document.createElement('a')
				// const href = window.URL.createObjectURL(blob)
				// // 后台在header中传文件名
				// link.href = href
				// // link.download = filenameStr
				// document.body.appendChild(link)
				// link.click()
				// document.body.removeChild(link) // 下载完成移除元素
				// window.URL.revokeObjectURL(href) // 释放掉blob对象
				// }

			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},

			initTableList() {

				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.tableData = [];
				this.KKCount = 0;
				this.KKSum = 0;
				this.czCount = 0;
				this.czSum = 0;
				this.hcCount = 0;
				this.hcSum = 0;
				this.tKCount = 0;
				this.tkSum = 0;
				// var ORMTB400ID
				// if (this.userobj.pertb005.pertb005cb00 == "CUS-2") {
				// 	this.customer = this.userobj.ormtb410.ORMTB410ID //一级企业id
				// 	ORMTB400ID = ''
				// }
				// if (this.userobj.pertb005.pertb005cb00 == "CUS-1") {
				// 	this.customer = this.customer
				// 	ORMTB400ID = this.userobj.ormtb400.ORMTB400ID //一级企业id

				// }
				// console.log(this.RechargetypeValue)
				if (this.RechargetypeValue == '全部') {
					this.RechargetypeValue = ''
				}
				var postData = {
					page: this.currentPage,
					limit: this.pageSize, //代码类型
					ORMTB410ID: this.customer, //客户名称
					// ORMTB400ID: ORMTB400ID, //流水号
					ORMTB520CA00: this.numberValue, //操作类型
					ORMTB420CA01: this.operateValue, //变动类型
					ORMTB520CA08: this.RechargetypeValue, //充值渠道
					startTime: this.startTime, //开始时间
					endTime: this.endTime, //结束时间
				}
				var url = "/orm/ormtb520/selectPageList";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 300)
					// console.log(res)
					if (res.data.code == 200) {
						this.tableData = res.data.data.ormtb520PageList;
						if (res.data.data.KK) {
							this.KKCount = res.data.data.KK.COUNT || 0;
							this.KKSum = res.data.data.KK.SUM || 0;
						}
						if (res.data.data.CZ) {
							this.czCount = res.data.data.CZ.COUNT || 0;
							this.czSum = res.data.data.CZ.SUM || 0;
						}
						if (res.data.data.HC) {
							this.hcCount = res.data.data.HC.COUNT || 0;
							this.hcSum = res.data.data.HC.SUM || 0;
						}
						if (res.data.data.TX) {
							this.tKCount = res.data.data.TX.COUNT || 0;
							this.tkSum = res.data.data.TX.SUM || 0;
						}
						this.recordCount = res.data.count;
						if (this.RechargetypeValue == '') {
							this.RechargetypeValue = '全部'
						}

					} else {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			//获取当前时间
			getNowDay() {
				var date = new Date().getTime();
				var Ming = new Date().getTime() + 24 * 60 * 60 * 1000;
				var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
				data = `${data} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [enddata, data];
				this.dateNowDayActive = true
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			datePickerChange(e) {
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			dateFtt(fmt, date) { //author: meizz
				var o = {
					"M+": date.getMonth() + 1, //月份 
					"d+": date.getDate(), //日 
					"h+": date.getHours(), //小时 
					"m+": date.getMinutes(), //分 
					"s+": date.getSeconds(), //秒 
					"q+": Math.floor((date.getMonth() + 3) / 3), //季度 
					"S": date.getMilliseconds() //毫秒 
				};
				if (/(y+)/.test(fmt))
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
				for (var k in o)
					if (new RegExp("(" + k + ")").test(fmt))
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
							.length)));
				return fmt;
			},
			//获取昨天时间
			getYesterday() {
				var hms = new Date().getTime() - 24 * 60 * 60 * 1000;
				var Ming = new Date().getTime();
				var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				nowDay = `${nowDay} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [nowDay, enddata];
				this.dateNowDayActive = false
				this.dateYesterdayActive = true
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},

			handleCheckAllChange(val) {
				this.checkedCities = val ? this.cities : [];
				this.isIndeterminate = false;
				this.tableHeadList = val ? this.tableHeadListInit : []
			},
			handleCheckedCitiesChange(value) {
				//console.log(value)
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.cities.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
				var changearr = this.checkedCities;
				var initarr = this.tableHeadListInit;
				this.tableHeadList = this.$baseAPI.columnSetup(changearr, initarr);
			},
			handleSizeChange(val) {
				// 每页显示的条数
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.pageSize = val;
				this.currentPage = 1;
				this.initTableList();
			},
			handleCurrentChange(val) {
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.currentPage = val;
				this.initTableList();
			},
			//导出excle
			daochuExport() {
				var userORMTB400ID
				
				var ORMTB410ID
				if (this.userobj.pertb005.pertb005cb00 == "CUS-2") {
					// userORMTB400ID = this.userobj.ormtb410.ORMTB400ID //一级企业id
					 ORMTB410ID = this.userobj.ormtb410.ORMTB410ID;

				}
				if (this.userobj.pertb005.pertb005cb00 == "CUS-1") {
					// userORMTB400ID = this.userobj.ormtb400.ORMTB400ID //一级企业id
					ORMTB410ID = this.customer;
				}
				if(this.RechargetypeValue == '全部'){
					this.RechargetypeValue = ''
				}
				
				// var ORMTB400ID = userORMTB400ID;
				var ORMTB520CA00 = this.numberValue;//操作类型
				var ORMTB520CA08 = this.RechargetypeValue;//充值渠道
				var ORMTB420CA01 = this.operateValue;

				var startTime = this.date[0]; //开始时间
				var endTime = this.date[1]; //结束时间
				var url = this.axios.defaults.baseURL + "/exc/toExcel/ormtb520toExcle?startTime=" + startTime +
					"&endTime=" + endTime + "&ORMTB410ID=" + ORMTB410ID + "&ORMTB420CA01=" +
					ORMTB420CA01 + "&ORMTB520CA00=" + ORMTB520CA00 + "&ORMTB520CA08=" + ORMTB520CA08

				window.location.href = url;
				if (this.RechargetypeValue == '') {
					this.RechargetypeValue = '全部'
				}
				this.loadingBut = true
				var timer = null //倒计时
				this.confirmTxt = 30 - 1
				timer = setInterval(() => {
					if (this.confirmTxt === 0) {
						this.confirmTxt = ""
						this.loadingBut = false
						clearInterval(timer);
					} else {
						this.confirmTxt--
					}
				}, 1000);
				


			},


			uploadFile() {
				var url = "exc/toExcel/download"
				var startTime = this.date[0]; //开始时间
				console.log(startTime)
				console.log(startTime.slice(0, 10))
				let dztime = startTime.slice(0, 10)
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					acDate: dztime
				}

				this.axios.post(url)
					.then(res => {
						console.log(res)
						//读取文件
						// 1.创建 FileReader 对象
						const fileReader = new FileReader()
						// 2.开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个字符串以表示所读取的文件内容。
						fileReader.readAsText(res.data) // 3.以字符串的形式读取出来
						fileReader.onload = () => {
							// 4.该事件在读取操作完成时触发。注意：此时this指向fileReader
							let result = JSON.parse(this.result) //获取的结果根据后端返回的数据类型选用json.parse
							if (result.code !== 0) {
								//如果读取失败进行响应的操作或提示
								return this.$message.error('文件读取失败')
							}
						}
						//导出文件
						// 通过a标签打开新页面下载文件
						const a = document.createElement('a')
						// 构造一个blob对象来处理数据
						const blob = new Blob[res.data]
						if (res.headers['content-disposition']) {
							// 拿到用户上传的文件名
							let fileName = res.headers['content-dispositon'].splice('filename=')[1]
							fileName = decodeURI(encodeURI(fileName))
							// URL.createObjectURL()会产生一个url字符串，可以像使用普通 URL 那样使用它，比如用在 img.src 上
							a.href = URL.createObjectURL(blob)
							// a标签里有download属性可以自定义文件名
							a.setAttribute(
								'download',
								fileName
							)
							document.body.appendChild(a)
							a.click();
							document.body.removeChild(a)
						}
					})
			},


			daochuReconciliationExport() {
				var userORMTB400ID
				// console.log(this.userobj)
				if (this.userobj.pertb005.pertb005cb00 == "CUS-2") {
					userORMTB400ID = this.userobj.ormtb410.ORMTB400ID //一级企业id

				}
				if (this.userobj.pertb005.pertb005cb00 == "CUS-1") {
					userORMTB400ID = this.userobj.ormtb400.ORMTB400ID //一级企业id

				}
				// console.log(userORMTB400ID)
				var ORMTB410ID = this.customer;
				var ORMTB400ID = userORMTB400ID;
				var ORMTB420CA00 = this.numberValue;
				var ORMTB420CA01 = this.operateValue;

				var startTime = this.date[0]; //开始时间
				console.log(startTime)
				console.log(startTime.slice(0, 10))
				let dztime = startTime.slice(0, 10)
				var endTime = this.date[1]; //结束时间
				var url = this.axios.defaults.baseURL + "/exc/toExcel/download?acDate=" + dztime
				window.location.href = url;
				this.loadingBut = true
				var timer = null //倒计时
				this.confirmTxtdzd = 30 - 1
				timer = setInterval(() => {
					if (this.confirmTxtdzd === 0) {
						this.confirmTxtdzd = ""
						this.loadingBut = false
						clearInterval(timer);
					} else {
						this.confirmTxtdzd--
					}
				}, 1000);


			},

			CZTypeQuery() {
				this.RechargetypeOptions = []

				var url = "/set/settb208/selectList"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.RechargetypeOptions = res.data.data
						// console.log(this.RechargetypeOptions)
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			queryClick() {
				this.czSum = 0;
				this.czCount = 0;
				this.KKSum = 0;
				this.KKCount = 0;
				this.tkSum = 0;
				this.tKCount = 0;
				this.hcSum = 0;
				this.hcCount = 0;
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.enterpriceSelect();
				this.initTableList();
			},
			quanPing() {
				var mark = 1;
				var objInfo = {
					startTime: this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(this.date[0])),
					endTime: this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(this.date[1])),
					customer: this.customer,
					customerOptions: this.customerOptions,
					carNum: this.carNum,
					operateValue: this.operateValue,
					RechargetypeValue: this.RechargetypeValue,
					numberValue: this.numberValue
				}
				sessionStorage.setItem(
					"qpSolelist",
					JSON.stringify(this.$store.state.solelist)
				);
				sessionStorage.setItem("CD01", JSON.stringify(this.$store.state.uobj.pertb005.pertb005cd01));
				sessionStorage.setItem("qpUobj", JSON.stringify(this.$store.state.uobj));
				sessionStorage.setItem("objInfo", JSON.stringify(objInfo));
				let Logistics = this.$router.resolve({
					path: '/BillDetails',
					query: {
						mark: mark
					}
				})
				this.$baseAPI.requestFullScreen(Logistics);
			},
			//获取当月
			getNowMonth() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms));
				firstDay = `${firstDay} ${this.exchangeTiem||'00:00:00'}`
				var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000;
				var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate));
				nextDay = `${nextDay} ${this.exchangeTiem||'00:00:00'}`
				this.date = [firstDay, nextDay];
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = true
				this.dateLastMonthActive = false
			},
			//获取上个月
			getLastMonth() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				var lastyear = year
				var lastmonth = month
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month == 12) {
					lastmonth = 1
				} else {
					lastmonth = lastmonth + (1 * 1)
				}
				if (month < 10) {
					month = "0" + month;
				}
				if (lastmonth < 10) {
					lastmonth = "0" + lastmonth;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem||'00:00:00'}`;
				// var lastDay = new Date(lastyear, lastmonth, 0);
				let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this.exchangeTiem||'00:00:00'}`;
				this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = true
			},

		}
	}
</script>

<style scoped>
	.zhezhao {
		position: fixed;
		top: 0;
		background: rgba(0, 0, 0, 0);
		text-align: center;
		height: 100%;
		width: 100%;
		z-index: 2003;
		left: 0;
		overflow: hidden;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_singleMenu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	/* 	.billOperationRecord .public_oparetionBlock_Menu{
		height: 45px;
		align-items: center;
	} */
	.billDetails {
		background: #f3f3f3;
	}

	.billDetails th,
	.billDetails td {
		text-align: center;
	}

	.tableHeadSet {
		position: absolute;
		margin-top: 3%;
		right: 26.5%;
		background: #ffffff;
		width: 10.417vw;
		height: 15.625vw;
		z-index: 99999999;
		box-shadow: 0px -0.521vw 0px 0px #f8f8f8, 0.521vw 0px 0px 0px #f8f8f8;
	}

	.salesWater_lieSetCheck label {
		width: 100%;
	}

	.salesWater_checkbox {
		display: block;
		margin-top: 4px;
	}

	.salesWater_arrow {
		font-size: 20px;
		vertical-align: middle;
	}

	.payType {
		font-size: 20px;
		/* font-size: 24px; */
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(102, 102, 102, 1);
		line-height: 26px;
	}

	.totolTitle {
		font-size: 16px !important;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
		line-height: 28px;
		margin-right: 5px;
		/* margin-right: 14px; */
		vertical-align: middle;
	}

	.singular {
		font-size: 32px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
		line-height: 30px;
		vertical-align: middle;
	}

	.billDetails-statistics {
		margin-right: 6px !important;
	}

	.billDetails-ul {
		margin-left: 10px !important;
	}

	.Amount {
		font-size: 32px;
		font-family: Microsoft YaHei;
		/* font-weight:bold; */
		line-height: 30px;
		vertical-align: middle;
	}
</style>
